var _defs, _rect, _polygon, _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSymbolPack367({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:none;stroke:#fff;stroke-miterlimit:10;stroke-width:0.5px;}.b{fill:#fff;}"))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "a",
    x: 4.03,
    y: 3.53,
    width: 8.42,
    height: 3.77,
    transform: "translate(3.81 -3.39) rotate(30)"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "a",
    points: "12.15 7.67 13.91 10.72 15.67 7.67 12.15 7.67"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M2.34,12.89l.33.1a1.4,1.4,0,0,1-.38.76.92.92,0,0,1-.66.25A1,1,0,0,1,1,13.83a1.15,1.15,0,0,1-.39-.54,2.08,2.08,0,0,1-.16-.87,1.94,1.94,0,0,1,.16-.84,1.13,1.13,0,0,1,.42-.51,1,1,0,0,1,.59-.18,1,1,0,0,1,.61.22,1.25,1.25,0,0,1,.36.65l-.32.1q-.16-.63-.66-.63a.71.71,0,0,0-.43.13.79.79,0,0,0-.28.39,1.65,1.65,0,0,0-.11.67,1.68,1.68,0,0,0,.21.93.7.7,0,0,0,.58.31.66.66,0,0,0,.46-.19A1,1,0,0,0,2.34,12.89Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M4.82,12.89l.33.1a1.4,1.4,0,0,1-.38.76.92.92,0,0,1-.66.25,1,1,0,0,1-.58-.17,1.1,1.1,0,0,1-.4-.54,2.36,2.36,0,0,1,0-1.71,1.13,1.13,0,0,1,.42-.51,1,1,0,0,1,.59-.18.93.93,0,0,1,.61.22,1.25,1.25,0,0,1,.36.65l-.32.1q-.17-.63-.66-.63a.68.68,0,0,0-.42.13.75.75,0,0,0-.29.39,1.65,1.65,0,0,0-.11.67,1.6,1.6,0,0,0,.22.93.67.67,0,0,0,.57.31.66.66,0,0,0,.46-.19A1,1,0,0,0,4.82,12.89Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M6.19,14V11.3H5.38V11h2v.35H6.51V14Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M8.36,14l-.95-3h.35l.64,2.17c0,.17.09.34.13.5,0-.17.08-.33.13-.5L9.33,11h.33l-1,3Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M9.6,13.05v-.38h.93v.38Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M10.9,14V11h.93a1.45,1.45,0,0,1,.48.05.61.61,0,0,1,.34.29.93.93,0,0,1,.13.52,1,1,0,0,1-.21.66.85.85,0,0,1-.71.26h-.63V14Zm.33-1.58h.64a.63.63,0,0,0,.44-.13.56.56,0,0,0,.14-.41.74.74,0,0,0-.07-.31.4.4,0,0,0-.17-.17.88.88,0,0,0-.35,0h-.63Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSymbolPack367);
export default __webpack_public_path__ + "static/media/Symbol_pack_367.468c39df0f1ec44737f57048d97d32aa.svg";
export { ForwardRef as ReactComponent };